import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { currentNodeState, combineStates, nodeState, screenState, mobileViewState, siteSettingsState, mobileViewDispatcher, showFooterDispatcher, combineDispatchers, currentPageState, currentPageDispatcher, identityState, screenSizeState } from '../../../store';
import { CategoryItem, Gallery, TreeView, HtmlComponent, SvgImage, BusyContainer } from '../../../components';
import { PropTypes } from 'prop-types';
import { getRouteToName, getResponsiveSize } from '../../../util';
import { VectorMobileTreeViewIcon, dotsIcon } from '../../../../style/images';
import { sessionStore, translate } from '../../../services';
import { Box, Grid, IconButton as MuiIconButton } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars';
import { BreadcrumbHeader, SiteFooter } from '../navigation';
import { GridViewSharp } from '@mui/icons-material';
import { Helmet } from 'react-helmet';
import { Banner } from '../navigation/Banner';

const defaultTreeViewWidth = 320;

const isActiveNode = currentNode => item => {
  // a node is active if it is the current node or one of it's children
  return currentNode.name === item.name || item.children.any( isActiveNode( currentNode ) );
};

export class CategoriesComponent extends Component {
  constructor() {
    super();
    this.pageCounter = 0;
    this.state = {
      treeViewWidth: sessionStore.get( 'treeViewWidth' ) || getResponsiveSize( defaultTreeViewWidth ),
      showBanner: true
    };

    this.resizeStart = this.resizeStart.bind( this );
    this.resizeTreeView = this.resizeTreeView.bind( this );
    this.resizeEnd = this.resizeEnd.bind( this );
  }

  componentDidMount() {
    this.mounted = true;
    window.addEventListener( 'resize', this.resizeTreeView );
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener( 'resize', this.resizeTreeView );
  }

  toggleBanner() {
    this.setState({showBanner: !this.state.showBanner});
  }

  getItemItemplate = item => {
    const htmlComponent = <HtmlComponent item={ item.name } tooltip={ item.name } />;
    return item.isExternal 
      ? <a href={ item.libraryLink } target={ '_blank' }>{ htmlComponent }</a> 
      : <Link to={ getRouteToName( item ) }>{ htmlComponent }</Link>;
  }

  resizeStart( e ) {
    window.addEventListener( 'mousemove', this.resizeTreeView );
    window.addEventListener( 'mouseup', this.resizeEnd );
  }

  resizeTreeView( e ) {
    const newWidth = e.clientX || getResponsiveSize( sessionStore.get( 'treeViewWidth' ) ) || getResponsiveSize( defaultTreeViewWidth );
    const maxSize = window.innerWidth - getResponsiveSize( 400 );
    const minSize = getResponsiveSize( defaultTreeViewWidth );

    if( newWidth >= minSize && newWidth <= maxSize ) {
      this.setState( { treeViewWidth: newWidth } );
      sessionStore.set( 'treeViewWidth', newWidth );
    }

    if( !e.clientX && newWidth > maxSize ) {
      this.setState( { treeViewWidth: maxSize } );
      sessionStore.set( 'treeViewWidth', maxSize );
    }

    if( !e.clientX && newWidth < minSize ) {
      this.setState( { treeViewWidth: minSize } );
      sessionStore.set( 'treeViewWidth', minSize );
    }
  }

  resizeEnd( e ) {
    window.removeEventListener( 'mousemove', this.resizeTreeView );
    window.removeEventListener( 'mouseup', this.resizeEnd );
  }

  onBack = () => this.pageCounter = this.pageCounter - 2;

  render() {
   if(this.props.currentPage.currentPage!=="categoriesPage"){
       this.props.setPage("categoriesPage")
    }
    this.props.showFooter();
    console.log("rendering")
    const { currentNode, node, screen, siteSettings } = this.props;
    if( !currentNode || !currentNode.children || currentNode.children.length === 0 ) {
      return null;
    }
    // const showTreeView = !screen || !screen.isMobile && !screen.isTablet;
    const showTreeView = this.props.screenSize.width>900
    const items = currentNode.children.where( child => child.isCategoryNode ).select();

    //for SEO meta tag
    let i = 0;
    const helmet = [];
    for (i = 0; i < currentNode.children.length; i++) {
      helmet.push(translate(currentNode.children[i].name));
    }

    const helmetdesc = [];
    for (i = 0; i < currentNode.children.length; i++) {
      helmetdesc.push(translate(currentNode.children[i].description));
    }
    
    // return <div className="categories">
    //   { 
    //     showTreeView && <TreeView 
    //       data={ node } 
    //       collapsible={ false } 
    //       childProperty="children"
    //       isActive={ isActiveNode( currentNode ) }
    //       itemTemplate={ this.getItemItemplate }
    //       width={ this.state.treeViewWidth }
    //     />
    //   }
    //   <div className="resize-border" onMouseDown={ this.resizeStart }>
    //     <SvgImage source={ dotsIcon }/>
    //   </div>
    //   <Gallery items={ items } itemTemplate={ CategoryItem } />
    // </div>;
    const currentDate = new Date();
    const cutoffDate = new Date('2024-09-02');
    return <BusyContainer actions={['filter-active']}>
      <Helmet>
        <title>eConfigure Devices</title>
        <meta name='description' content={helmetdesc.join()}/>
        <meta name='keywords' content={helmet.join()}/>
      </Helmet>
       <Grid item container xl={12} md={12} xs={12} sx={{height:"100%", width:"100%"}} overflowY="auto">
      <Grid item borderRight="1px solid #EBEBEB" xl={2.5} lg={3} md={3} sx={{width:{md:"313px"}, display:{xl:"flex", md:"flex",  xs:"none"}, height:"100%"}} overflow= "auto">
          {showTreeView && <TreeView data={ node } 
                    collapsible={ false } 
                    childProperty="children"
                    isActive={ isActiveNode( currentNode ) }
                    itemTemplate={ this.getItemItemplate }
                    width={ this.state.treeViewWidth }
                    border="0px solid #EBEBEB"
                    mt="24px"></TreeView>}
      </Grid>
      {/* <Grid item container spacing={0} xl={9.5} lg={9} md={9} border={0} sx={{display:{xl:"flex", md:"flex", xs:"none"}, height: '100%', overflowY:"auto"}}>
          <Grid item container xl={12} md={12} xs="none" height={{xl:"5%", md:"20px"}}>
          <BreadcrumbHeader 
              setBack={ this.pageCounter > 1 }
              onBack={ this.onBack }
              isIntegrated={ siteSettings.isIntegrated } 
              pathname={ document.location.hash }
            />
          </Grid>
          <Grid item container xl={12} md={12} xs="none" height={{md:"max-content"}} sx={{display:{xl:"flex", md:"flex", xs:"none"}}}>
            <Gallery items={ items } itemTemplate={ CategoryItem } />
          </Grid>   
      </Grid> */}
      <Grid item container spacing={0} xl={9.5} lg={9} md={9} border={0} sx={{display:{xl:"flex", md:"flex", xs:"none"}, height: '100%', overflowY:"auto"}}>
            <Banner></Banner>
          <div style={{height:"100%",width:"100%", display:"flex", justifyContent:"start", flexDirection:"column"}}>
          {currentDate < cutoffDate && this.state.showBanner && this.props.user.country.toLowerCase()==="de" && <div className='de-banner'> 
            <div className='banner-content'> 
              <div className='detail'>
                <span className='bold'>GIT Sicherheit Award 2025: </span>
                <span className='light'>Mit der mobilen Zweihandbedieneinheit sind wir unter den Finalisten!</span>
              </div>
              <span className='link' onClick = {()=>window.open('https://git-sicherheit.de/de/award/git-sicherheit-award-2025/')}>Hier geht‘s zur Abstimmung</span>
            </div>
            <div className='button' onClick={()=>this.toggleBanner()}>
            <span>{translate('Close')}</span>
            </div>
          </div>}
          <Box width="100%" xs="none" height={{md:"5%"}}>
          <BreadcrumbHeader 
              setBack={ this.pageCounter > 1 }
              onBack={ this.onBack }
              isIntegrated={ siteSettings.isIntegrated } 
              pathname={ document.location.hash }
            />
          </Box>
          <Grid item container xl={12} md={12} xs="none" height={{md:"max-content"}} sx={{display:{xl:"flex", md:"flex", xs:"none"}}}>
            <Gallery items={ items } itemTemplate={ CategoryItem } user={this.props.user}/>
          </Grid>
          </div>  
      </Grid>
      <Grid item container xs={12} sm={12} sx={{display:{xl:"none", md:"none",sm:"flex", xs:"flex"},height:"100%"}}>
      <Grid item xs={12} sx={{display:{xl:"none", md:"none", xs:!this.state.isSearchOn?"flex":"none"},mt:"1px", height:{xs:"7%"}, background:"#FFFFFF", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)"}}>
            <Box sx={{display:"flex", flexDirection:"row", justifyContent:"space-between",
              alignItems: "center",
              padding: "7px 16px",
              gap: "64px",
              height:"100%",
              width:"100%",
              borderTop: "1px solid #DBDBDB",
              }}>
              <Box>
                <BreadcrumbHeader 
                setBack={ true }
                onBack={ this.onBack }
                isIntegrated={ siteSettings.isIntegrated } 
                pathname={ document.location.hash }
                fromMobileHeader = {true}
              />
              </Box>
              <Box flexGrow={1}>
              </Box>
              <Box sx={{display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  width: "108px",
                  height: "38px", 
                  padding: "4px",
                  background: "#EBEBEB",
                  gap: "4px", borderRadius:"4px"}}>
                  <Box  sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "8px 16px",
                        gap: "10px",
                        width: "48px",
                        height: "30px",
                        borderRadius:"4px",
                        background: this.props.mobileContentView.view==="mediaView"?"#FFFFFF":"#EBEBEB"
                      }}>
                      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{this.props.mediaView()}}>
                        <GridViewSharp sx={{fontSize:"18.68px", color:"#0F0F0F"}} ></GridViewSharp>
                      </MuiIconButton>
                      
                  </Box>
                  <Box  sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "8px 16px",
                        gap: "10px",
                        width: "48px",
                        height: "30px",
                        }}>
                        <Box  sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "8px 16px",
                        gap: "10px",
                        width: "48px",
                        height: "30px",
                        borderRadius:"4px",
                        background: this.props.mobileContentView.view==="listView"?"#FFFFFF":"#EBEBEB"
                      }}>
                        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{this.props.listView()}}>
                          <Box component="img" src={VectorMobileTreeViewIcon} width="12px" height="10px"></Box>
                        </MuiIconButton>
                      </Box> 
                  </Box>
              </Box>
            </Box>
        </Grid>
        <Grid item container sx={{height:"calc(93% - 148px)"}}>
        <Banner mobileView></Banner>
          {this.props.mobileContentView.view==="listView"?<TreeView data={ node }
                className = "treeViewMain" 
                collapsible={ false } 
                childProperty="children"
                isActive={ isActiveNode( currentNode ) }
                itemTemplate={ this.getItemItemplate }
                width={ this.state.treeViewWidth }
                border="0px solid #EBEBEB"
                overflowY="auto"
                mobileParentTreeView={true}
                currentNode={currentNode}></TreeView>:
                // <Grid item container xl={10} md={10} sx={{display:{xl:"none", md:"none", xs:"flex"}, height: '100%', overflowY:"auto", overflowX:"hidden"}}>
                //   <Box width="100%" height="max-content">
                //   <BreadcrumbHeader 
                //       setBack={ this.pageCounter > 1 }
                //       onBack={ this.onBack }
                //       isIntegrated={ siteSettings.isIntegrated } 
                //       pathname={ document.location.hash }
                //       mobileTileView={true}
                //     />
                //   </Box>
                //   <Grid item xs={12} sx={{display:{xl:"none", md:"none", xs:"flex"},marginTop:"16px", height:"max-content", overflowY:"auto", overflowX:"hidden"}}>
                //     <Gallery items={ items } itemTemplate={ CategoryItem } />
                //   </Grid>
                // </Grid>
                <Box width="100%" sx={{display:{xl:"none", md:"none", xs:"flex"},flexDirection:"column", height: "100%", overflowY:"auto", overflowX:"hidden"}}>
                  <div style={{width:"100%", height:"100%", overflowY:"auto", marginTop:"16px"}}>
                  <Box width="100%" height="max-content">
                  <BreadcrumbHeader 
                      setBack={ this.pageCounter > 1 }
                      onBack={ this.onBack }
                      isIntegrated={ siteSettings.isIntegrated } 
                      pathname={ document.location.hash }
                      mobileTileView={true}
                    />
                  </Box>
                  <Grid item xs={12} sx={{display:{xl:"none", md:"none", xs:"flex"}, height:"max-content", overflowY:"auto", overflowX:"hidden"}}>
                    <Gallery items={ items } itemTemplate={ CategoryItem } />
                  </Grid>
                  </div>
                </Box>
                }
        </Grid>
        <Grid item container sx={{height:"148px", borderTop:"1px solid var(--primary-color-grey-20, #DBDBDB)"}}>
        <SiteFooter></SiteFooter>
        </Grid>
      </Grid>
    </Grid>   
    </BusyContainer>
      
  }
}

CategoriesComponent.propTypes = {
  currentNode: PropTypes.shape( {
    children: PropTypes.array,
    parent: PropTypes.object
  } ),
  node: PropTypes.shape( {} ),
  screen: PropTypes.shape( {
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired
  } )
};

export const Categories = connect( combineStates( currentNodeState, nodeState, screenState, mobileViewState, siteSettingsState, mobileViewState, currentPageState, identityState,screenSizeState ), combineDispatchers(mobileViewDispatcher, showFooterDispatcher, currentPageDispatcher) )( CategoriesComponent );